<template>

  <div class="content" style="background-color: white">
    <div style="margin-bottom: 1.5rem">
      <nav class="bar bar-nav">
        <a class="button button-link button-nav pull-left"  @click="gotolast()" v-if="!isWapp" >
          <span class="icon icon-left"></span>返回
        </a>
      </nav>
    </div>
<div  style="margin-top: 2rem">
  <newMerchandiseListA :merchList="merchdiseGroup" :description="'group'"  ></newMerchandiseListA>
</div>


  </div>
  <!--</div>-->
</template>
<script>
  import {mapState} from 'vuex'
  import merchdata from '../../components/MerchandiseList.vue'
  import newMerchandiseListA from '../finder/components/NewMerchandiseListA.vue'
  import emkt from '../../emkt.js'
  export default {
    mounted () {
      // console.log('mounted')
    },
    created () {
//      this.fetchData()
    },
    data () {
      return {
        compositions: [],
        isWapp: emkt.isWapp
      }
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      // '$route': 'fetchData'
    },
    components: {
      merchdata, newMerchandiseListA
    },
    computed: {
      ...mapState([
        'merchdiseGroup'
        // ...
      ])
    },
    methods: {
      fetchData () {
      },
      tolast () {
        this.$router.go(-1)
      },
      gotolast () {
        this.$router.go(-1)
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .button{
    color: #0a8ddf;
    border: 0rem;
    font-size: 1rem
  }
</style>



// WEBPACK FOOTER //
// Compositions.vue?17f3b248